export default __webpack_public_path__ + "static/media/tourTeam.0c4235ba.png";